import { Link } from "react-router-dom";
import type { Work } from "@/types/content";
import { categoryName, coverOf, formatViews } from "@/lib/content";

interface HotRankingProps {
  works: Work[];
}

export default function HotRanking({ works }: HotRankingProps) {
  return (
    <div className="grid grid-cols-1 gap-x-8 gap-y-1 md:grid-cols-2">
      {works.map((work, index) => (
        <Link
          key={work.id}
          to={`/detail/${work.id}`}
          className="group flex cursor-pointer items-center gap-3 rounded-lg border border-transparent px-2 py-2.5 transition hover:border-background-300/60 hover:bg-background-100"
        >
          <span
            className={`w-7 flex-shrink-0 text-center font-heading text-lg font-extrabold ${
              index < 3 ? "text-primary-400" : "text-foreground-700"
            }`}
          >
            {String(index + 1).padStart(2, "0")}
          </span>
          <div className="relative h-16 w-12 flex-shrink-0 overflow-hidden rounded bg-background-200">
            <img
              src={coverOf(work)}
              alt={`${work.title}封面`}
              title={`${work.title} · ${categoryName(work.category)}`}
              className="h-full w-full object-cover object-top transition duration-500 group-hover:scale-105"
            />
          </div>
          <div className="min-w-0 flex-1">
            <h3 className="truncate text-[13px] font-medium text-foreground-100 transition group-hover:text-primary-300 md:text-sm">
              {work.title}
            </h3>
            <p className="mt-1 truncate text-[11px] text-foreground-500">
              {categoryName(work.category)} · {work.region} · {work.year}
            </p>
            <p className="mt-1 flex items-center gap-3 text-[11px] text-foreground-600">
              <span className="flex items-center gap-1">
                <i className="ri-eye-line" />
                {formatViews(work.views)}
              </span>
              <span className="flex items-center gap-1 text-primary-500">
                <i className="ri-star-fill text-[9px]" />
                {work.rating.toFixed(1)}
              </span>
            </p>
          </div>
          <i className="ri-arrow-right-up-line flex-shrink-0 text-foreground-700 transition group-hover:text-primary-400" />
        </Link>
      ))}
    </div>
  );
}